import React from 'react';
import './InvoiceInfo.css'; // You can style this page as needed

const InvoiceInfo = () => {
    return (
        <div className="thank-you-page">
            <div className="cart-container">
                <h1>Thank you for your Order!</h1>
                <p>Your order has been successfully processed. We will send you an email confirmation shortly.</p>
            </div>
        </div>
    );
};

export default InvoiceInfo;  /* InvoiceInfo-specific styling */
